import { render, staticRenderFns } from "./addFaceInfoV2.vue?vue&type=template&id=623f562a&scoped=true&"
import script from "./addFaceInfoV2.vue?vue&type=script&lang=js&"
export * from "./addFaceInfoV2.vue?vue&type=script&lang=js&"
import style0 from "./addFaceInfoV2.vue?vue&type=style&index=0&id=623f562a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623f562a",
  null
  
)

export default component.exports